import classNames from 'classnames'
import { getBackendUrl } from '../../helpers/url'
import { useQuery } from 'react-query'
import { LiveGameTechDisplay } from './LiveGameTechDisplay'
import { LiveGameKeyTech } from './LiveGameKeyTech'
import { getPbgidIcon, usePbgidIcons } from '../../helpers/pbgidIcons'

export function LiveGameDocks({ playerData, leftSide, color }) {
	const pbgidIcons = usePbgidIcons()

	const fetchCivs = async () => {
		const res = await fetch(`${getBackendUrl()}/api/config/civs`)
		return res.json()
	}

	const { data } = useQuery('civs', fetchCivs)

	const selectedCiv = data?.find((value) => value.aoe2cm === playerData?.civilization || value.label === playerData?.civilization)
	let playerTechs = Object.values(playerData?.technologiesResearched || []).map(String)

	const renderTech = (tech, key) => <LiveGameTechDisplay key={key} pbg_id={tech?.pbgid} hasTech={playerTechs.includes(String(tech?.pbgid))} isUnique={tech?.isUnique || false} />

	return (
		<div
			className={classNames(`w-auto h-auto border-solid border flex flex-col`, leftSide ? '-ml-3' : '-mr-3')}
			style={{
				borderColor: 'var(--main-color)',
				backgroundImage: 'url("/sheepCounter/background.png")',
			}}>
			<div className={classNames('flex flex-col gap-4 px-4 py-4')}>
				{selectedCiv?.dockUpgrades?.map((row, rowIndex) => (
					<div key={rowIndex} className={classNames('flex flex-wrap gap-1 flex-row items-start')}>
						{row.map((item, i) =>
							// A nested array is a tiered upgrade line, shown as one icon with a dot per tier
							Array.isArray(item) ? (
								<LiveGameKeyTech
									key={'group' + i}
									tech={{
										icon: getPbgidIcon(pbgidIcons, parseInt(item[0]?.pbgid)) || '/liveGameIcons/unknown.png',
										requiredUpgrades: item.map((tech) => parseInt(tech?.pbgid)),
										maxTechs: item.length,
									}}
									currentUpgrades={playerTechs}
									color={color}
								/>
							) : (
								renderTech(item, item?.pbgid + String(i))
							),
						)}
					</div>
				))}
			</div>
		</div>
	)
}
